// DevWars — см. .agents/skills/devwars/SKILL.md

export const DEV_COUNTRIES = {
  RU: { name: 'Россия', currency: 'RUB', host: 'ru.coral.club' },
  BY: { name: 'Беларусь', currency: 'BYN', host: 'by.coral.club' },
  JE: { name: 'Channel Islands', currency: 'EUR', host: 'je.coral.club' },
  UA: { name: 'Україна', currency: 'UAH', host: 'ua.coral.club' },
  PL: {
    name: 'Polska',
    currency: 'PLN',
    host: 'pl.coral.club',
    language: 'pl',
  },
  CCI: {
    name: 'Polska (CCI)',
    currency: 'EUR',
    host: 'cci.coral.club',
    language: 'pl',
  },
  CZ: { name: 'Česká republika', currency: 'EUR', host: 'cz.coral.club' },
  GR: { name: 'Greece', currency: 'EUR', host: 'gr.coral.club' },
  DE: { name: 'Deutschland', currency: 'EUR', host: 'de.coral.club' },
  ES: { name: 'España', currency: 'EUR', host: 'es.coral.club' },
  LV: { name: 'Latvija', currency: 'EUR', host: 'lv.coral.club' },
  SK: { name: 'Словакия', currency: 'EUR', host: 'sk.coral.club' },
  LT: { name: 'Lietuva', currency: 'EUR', host: 'lt.coral.club' },
  IT: { name: 'Italia', currency: 'EUR', host: 'it.coral.club' },
  RO: { name: 'Romania', currency: 'EUR', host: 'ro.coral.club' },
  EE: { name: 'Estonia', currency: 'EUR', host: 'ee.coral.club' },
  GB: { name: 'United Kingdom', currency: 'GBP', host: 'gb.coral.club' },
  US: { name: 'United States', currency: 'USD', host: 'us.coral.club' },
  KZ: { name: 'Казахстан', currency: 'KZT', host: 'kz.coral.club' },
  NO: { name: 'Norway', currency: 'NOK', host: 'no.coral.club' },
  UZ: { name: 'Узбекистан', currency: 'UZS', host: 'uz.coral.club' },
  AM: { name: 'Армения', currency: 'AMD', host: 'am.coral.club' },
  TW: { name: 'Тайвань', currency: 'USD', host: 'tw.coral.club' },
  FI: { name: 'Finland', currency: 'EUR', host: 'fi.coral.club' },
  FR: { name: 'France', currency: 'EUR', host: 'fr.coral.club' },
  CA: { name: 'Canada', currency: 'CAD', host: 'ca.coral.club' },
  IL: { name: 'Israel', currency: 'ILS', host: 'il.coral.club' },
  CH: { name: 'Switzerland', currency: 'CHF', host: 'ch.coral.club' },
  AT: { name: 'Austria', currency: 'EUR', host: 'at.coral.club' },
  KR: { name: 'South Korea', currency: 'KRW', host: 'kr.coral.club' },
  HU: { name: 'Magyarország', currency: 'HUF', host: 'hu.coral.club' },
  GE: { name: 'Georgia', currency: 'GEL', host: 'ge.coral.club' },
  BE: { name: 'Belgium', currency: 'EUR', host: 'be.coral.club' },
  PT: { name: 'Portugal', currency: 'EUR', host: 'pt.coral.club' },
  IN: { name: 'India', currency: 'INR', host: 'in.coral.club' },
  TR: { name: 'Turkey', currency: 'EUR', host: 'tr.coral.club' },
  QA: { name: 'Qatar', currency: 'EUR', host: 'qa.coral.club' },
  AU: { name: 'Australia', currency: 'EUR', host: 'au.coral.club' },
  CY: { name: 'Cyprus', currency: 'EUR', host: 'cy.coral.club' },
}

// Окружение бэкенда (куда проксируются /sv-api и /restApi).
//   prod    → {cc}.coral.club          (явный host из карты стран)
//   preprod → {cc}.coralorder.online
//   devN    → {cc}.dev{N}.coralclub.app  (N = 0..DEV_ENV_DEV_MAX)
export const DEV_DEFAULT_ENV = 'prod'
export const DEV_ENV_DEV_MAX = 15
export const DEV_ENV_TYPES = [
  { key: 'prod', label: 'Prod' },
  { key: 'preprod', label: 'Preprod' },
  { key: 'dev', label: 'Dev' },
]

// Внутренний ключ окружения — это 'prod' | 'preprod' | 'dev0'..'dev{MAX}'.
export function isValidEnv(value) {
  if (value === 'prod' || value === 'preprod') return true
  return /^dev([0-9]|1[0-5])$/.test(String(value))
}

export function normalizeEnv(value) {
  return isValidEnv(value) ? value : DEV_DEFAULT_ENV
}

// Хост бэкенда по ключу окружения + коду страны.
export function buildBackendHost(envKey, countryCode) {
  const cc = String(countryCode || 'ru').toLowerCase()
  if (envKey === 'preprod') return `${cc}.coralorder.online`
  const devMatch = /^dev([0-9]|1[0-5])$/.exec(String(envKey))
  if (devMatch) return `${cc}.dev${devMatch[1]}.coralclub.app`
  // production — предпочитаем явный host из карты стран (нулевой риск
  // регресса: поведение для prod остаётся прежним), иначе стандартный шаблон.
  const def = DEV_COUNTRIES[String(countryCode).toUpperCase()]
  return def?.host || `${cc}.coral.club`
}

// Пользователь, под которым «авизована» dev-сессия (fAuth в api.js).
export const DEV_AUTH_USERS = [
  { label: 'Гость', fAuth: '' },
  { label: '2804051', fAuth: '2804051' },
  { label: '2808641', fAuth: '2808641' },
]

// Доступные языки в панели. null = «авто» (по стране).
export const DEV_LANGUAGES = [
  'ru',
  'pl',
  'en',
  'uk',
  'de',
  'es',
  'it',
  'ro',
  'cs',
]

// Mock-профиль по умолчанию (поля person).
export const DEV_DEFAULT_PERSON = {
  FIO: 'asdasd',
  PHONE: '+35023423423342',
  EMAIL: 'asd@mail.ru',
}

export const DEV_ACTIVE_DEFAULT = {
  country: 'RU',
  fAuth: '2804051',
  language: null,
  IS_COUNTRY_GLOBAL: false,
  curLocation: null,
  personOverride: null,
  environment: DEV_DEFAULT_ENV,
}
